import * as types from './action-types';

const initialState = {
  error: false,
  message: ''
};

const server = (state = initialState, action) => {
  switch (action.type) {

    case types.SERVER_ERROR: {

      return Object.assign({}, state, {
        error: true,
        status: action.status,
        message: action.msg
      });
    }

    case types.CLEAR_SERVER_ERROR:
      return initialState;

    default:
      return state;
  }
};

export default server;



// WEBPACK FOOTER //
// ./src/server/reducer.js